<div class="trial-badge" [ngClass]="{ 'trial-badge--expired': expired }">
  <button
    type="button"
    class="trial-badge__trigger"
    [attr.aria-expanded]="expanded"
    [title]="message"
    (click)="toggle()"
  >
    <fa-icon [icon]="expired ? faTriangleExclamation : faClock"></fa-icon>
    @if (!expired && daysRemaining !== null) {
      <span class="trial-badge__count">{{ daysRemaining }}</span>
    }
  </button>

  @if (expanded) {
    <div class="trial-badge__panel">
      <button
        type="button"
        class="trial-badge__close"
        aria-label="Cerrar"
        (click)="collapse()"
      >
        <fa-icon [icon]="faXmark"></fa-icon>
      </button>
      <p class="trial-badge__message">{{ message }}</p>
      <a
        class="trial-badge__action"
        [routerLink]="['/dashboard/settings', 'payments']"
        (click)="collapse()"
      >
        Ver planes
      </a>
    </div>
  }
</div>
